import { useEffect, useCallback } from "react";
import { $generateHtmlFromNodes } from "@lexical/html";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { debounce } from "lodash";

type LocalStoragePluginProps = { namespace: string };

const LocalStoragePlugin = ({ namespace }: LocalStoragePluginProps) => {
	const [editor] = useLexicalComposerContext();

	const saveToLocalStorage = useCallback(
		(content: string) => {
			localStorage.setItem(namespace, content);
		},
		[namespace],
	);

	const debouncedSaveToLocalStorage = debounce(saveToLocalStorage, 500);

	useEffect(() => {
		return editor.registerUpdateListener(
			({ editorState, dirtyElements, dirtyLeaves }) => {
				// Don't update if nothing changed
				if (dirtyElements.size === 0 && dirtyLeaves.size === 0) return;

				editorState?.read(() => {
					const htmlState = $generateHtmlFromNodes(editor);
					debouncedSaveToLocalStorage(htmlState);
				});
			},
		);
	}, [debouncedSaveToLocalStorage, editor]);

	return null;
};

export default LocalStoragePlugin;
